import React, { ComponentProps } from 'react'

import { TextLink, useFont } from '@octane/spark'
import styled from 'styled-components'

interface RowProps {
    gridTemplateColumns: string
}

export const Row = styled.div<RowProps>`
    display: grid;
    grid-template-columns: ${(props) => props.gridTemplateColumns};
    grid-column-gap: 20px;
    grid-row-gap: 20px;

    :last-child {
        margin-bottom: 0;
    }
`

export const CheckContainer = styled.div`
    display: flex;
`
export const ErrorMessage = styled.span`
    ${() => useFont('c12', { weight: '400' })};
    color: ${(props) => props.theme.colors.alert.warning};
    margin-top: -15px;
`
export const ResidenceParagraph = styled.p`
    margin: 3px 0 0 0;
    padding-left: 1vw;
    ${() => useFont('c14', { weight: '400' })};
    line-height: 20px;
`

export const ComponentRow = styled(Row)`
    margin-bottom: 20px;
`

export const ConditionTabWrapper = styled.div`
    width: 50%;
    margin-bottom: 20px;
`

function RemoveLinkBase(props: ComponentProps<typeof TextLink>) {
    return <TextLink as="button" variant="simple" {...props} />
}

export const RemoveLink = styled(RemoveLinkBase)`
    color: ${(props) => props.theme.colors.alert.warning};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    svg {
        fill: ${(props) => props.theme.colors.alert.warning};
    }

    &:hover {
        color: ${(props) => props.theme.colors.alert.warning};

        svg {
            fill: ${(props) => props.theme.colors.alert.warning};
        }
    }
`
